import { Typography } from '@eventr/common-storybook'

export const FadedText = (props: { text: string }) => {
    return (
        <Typography
            variant="bodyRegular"
            width="100%"
            padding="16px 16px"
            display="flex"
            justifyContent="center"
            textAlign={'center'}
            boxSizing={'border-box'}
            style={{ opacity: '0.5' }}
        >
            {props.text}
        </Typography>
    )
}
